var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableUploadGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#25B003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.9C7.77614 16.9 8 17.1239 8 17.4V19.9C8 20.4523 8.44772 20.9 9 20.9H21C21.5523 20.9 22 20.4523 22 19.9V17.4C22 17.1239 22.2239 16.9 22.5 16.9C22.7761 16.9 23 17.1239 23 17.4V19.9C23 21.0046 22.1046 21.9 21 21.9H9C7.89543 21.9 7 21.0046 7 19.9V17.4C7 17.1239 7.22386 16.9 7.5 16.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6464 8.14645C14.8417 7.95118 15.1583 7.95118 15.3536 8.14645L18.3536 11.1464C18.5488 11.3417 18.5488 11.6583 18.3536 11.8536C18.1583 12.0488 17.8417 12.0488 17.6464 11.8536L15.5 9.70711V18.5C15.5 18.7761 15.2761 19 15 19C14.7239 19 14.5 18.7761 14.5 18.5V9.70711L12.3536 11.8536C12.1583 12.0488 11.8417 12.0488 11.6464 11.8536C11.4512 11.6583 11.4512 11.3417 11.6464 11.1464L14.6464 8.14645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableUploadGreenIcon);
export default __webpack_public_path__ + "static/media/table-upload-green-icon.fb66778546ca079c23dcad400a1ef3db.svg";
export { ForwardRef as ReactComponent };